/**
* @name APP parvulo
* @description
* # name controller --> levelsCreateController
* # As Controller --> levelsCreate
* brief comment controller creation levels users
*/

export default class levelsCreateController {
  	constructor($scope,levelsServices,ngNotify,UserInfoConstant,$state,$filter) {
		this.$scope = $scope
		this.ngNotify = ngNotify
		this.$state = $state 
		this.services   = levelsServices.services
		this.$scope.name = ''
		this.$scope.grid = false
		this.$translate = $filter('translate');
        this.conceptId = 0
		
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});
   	}

	init(){
	}

	beforeSave(){
		this.$scope.isDisabled = true;
		let params  = { 
			name   : this.$scope.name,
			user_id : this.user_id,
			concept_id: this.conceptId
			
		}

		this.save(params)
	}

	save(params){
		this.services.saveLevels(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha creado el Nivel correctamente','success');
				this.$state.go("app.levels");
			}else{
				this.ngNotify.set('Error con servicio check request','error');
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio, Verifique si existe Nivel','error');
			this.$scope.isDisabled = false;
		})
	}
}
levelsCreateController.$inject=['$scope', 'levelsServices','ngNotify','UserInfoConstant','$state','$filter']








// WEBPACK FOOTER //
// ./src/app/admin-panel/levels/create/levelsCreateController.js